import { cn } from '@/lib/utils/cn';
import { formatoCantidad } from '@/lib/utils/formato-precio';

export interface OpcionDelGrupo<T extends string> {
  valor: T;
  texto: string;
  /** El número al lado («Por decidir 29»). null o ausente = no se muestra. */
  cuenta?: number | null;
}

/**
 * Un grupo de botones pegados, uno elegido (mapa de diseño 226; maqueta del
 * pulido): los estados de Por decidir, los tipos de Reglas, los modos de
 * Análisis. El elegido lleva `aria-pressed` y el fondo azul suave.
 */
export function GrupoDeOpciones<T extends string>({
  opciones,
  valor,
  onCambiar,
  className,
  'aria-label': etiqueta,
}: {
  opciones: Array<OpcionDelGrupo<T>>;
  valor: T;
  onCambiar: (v: T) => void;
  className?: string;
  'aria-label': string;
}) {
  return (
    <div
      role="group"
      aria-label={etiqueta}
      className={cn('inline-flex overflow-hidden rounded-md border bg-campo', className)}
    >
      {opciones.map((o, i) => {
        const elegida = o.valor === valor;
        return (
          <button
            key={o.valor}
            type="button"
            aria-pressed={elegida}
            onClick={() => onCambiar(o.valor)}
            className={cn(
              'inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-foreground/80 hover:bg-muted/60',
              i > 0 && 'border-l',
              elegida && 'bg-primary/10 font-semibold text-primary hover:bg-primary/10'
            )}
          >
            {o.texto}
            {/* El espacio es para el nombre accesible («Por decidir 29»); la separación la da `gap`. */}
            {o.cuenta != null && ' '}
            {o.cuenta != null && (
              <span
                className={cn(
                  'text-xs font-medium tabular-nums',
                  elegida ? 'text-primary' : 'text-muted-foreground'
                )}
              >
                {formatoCantidad(o.cuenta)}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
